Object.defineProperty(exports, "__esModule", { value: true });
exports.useEmbeds = void 0;
const react_1 = require("react");
const admin_core_1 = require("@wheelroom/admin-core");
exports.useEmbeds = (gatsbyProps) => {
    const { adminCoreState } = react_1.useContext(admin_core_1.AdminCoreContext);
    const [embedsDone, setEmbedsDone] = react_1.useState(false);
    const globals = gatsbyProps.data.globals;
    if (!embedsDone && globals.siteEmbeds && Array.isArray(globals.siteEmbeds)) {
        const isAppInit = adminCoreState.lastModuleId === '*';
        globals.siteEmbeds.forEach((embed) => {
            if (embed.code && embed.type === 'js-page') {
                Function('props', embed.code.code)(gatsbyProps);
            }
            if (isAppInit && embed.code && embed.type === 'js-app') {
                Function('props', embed.code.code)(gatsbyProps);
            }
        });
        setEmbedsDone(true);
    }
};
//# sourceMappingURL=use-embed.js.map